"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var PlanSelectorTileHeader = function PlanSelectorTileHeader(_ref) {
  var hub = _ref.hub;
  return _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.plansHeader." + hub
  }));
};

var _default = PlanSelectorTileHeader;
exports.default = _default;
module.exports = exports.default;